import angular from 'angular';

export const MovimentacoesListRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider): void {
		const accessResolve = [
            '$rootScope',
            '$state',
            '$q',
            function (
                $rootScope: angular.IRootScopeService & {
                    liberadoTela: (arg: string) => boolean,
                    temPermissao: (arg: string) => boolean,
                },
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (
                    $rootScope.liberadoTela('LIBERAR_GESTAO_MOVIMENTACOES') &&
                    $rootScope.temPermissao('visualizar_movimentacao')
                ) {
                    return true;
                }

                $state.go('dp');
                return $q.reject('Acesso negado ao módulo de movimentações.');
            }
        ];

		$stateProvider
			.state('movimentacoes', {
				url: '/movimentacoes?periodo&movimentacao',
				template: require('html-loader!./index/movimentacoes.index.html'),
                resolve: {
                    'access': accessResolve
                },
				controller: 'MovimentacoesIndexController',
				controllerAs: 'mvmntcs_ndx_cntrllr',
				reloadOnSearch: false
			});
	}
];
